class RolesDelegate {
    selectRole(roleId) {
        this.setState({ selectedRoleId: roleId, pendingScopeIds: null, scopeSearch: '' });
    }

    setScopeSearch(scopeSearch) {
        this.setState({ scopeSearch });
    }

    setNewRoleModalOpen(newRoleModalOpen) {
        this.setState((prev) => ({
            newRoleModalOpen,
            newRoleName: newRoleModalOpen ? prev.newRoleName : '',
            newRoleDescription: newRoleModalOpen ? prev.newRoleDescription : '',
            newRoleCloneFromId: newRoleModalOpen ? prev.newRoleCloneFromId : null,
        }));
    }

    setNewRoleName(newRoleName) {
        this.setState({ newRoleName });
    }

    setNewRoleDescription(newRoleDescription) {
        this.setState({ newRoleDescription });
    }

    setNewRoleCloneFromId(newRoleCloneFromId) {
        this.setState({ newRoleCloneFromId });
    }

    /** Toggle a scope on the currently-selected role, tracked as a pending
     * (unsaved) diff against the role's committed scope_ids. */
    toggleScope(scopeId) {
        this.setState((prev) => {
            const committed = prev.roles.find((r) => r.id === prev.selectedRoleId)?.scope_ids || [];
            const current = prev.pendingScopeIds ?? committed;
            const next = current.includes(scopeId)
                ? current.filter((id) => id !== scopeId)
                : [...current, scopeId];
            return { pendingScopeIds: next };
        });
    }
}

export default RolesDelegate;
